import { Step } from "../ui/stepper";
import { Button } from "../ui/button";
import { cn } from "../../lib/utils";

export const CompanionFormStep = ({
  children,
  className,
  id,
  back = null,
  backChildren = "Previous",

  next = null,
  nextChildren = "Next",
  nextDisabled = false,
  ...props
}) => {
  const handleBack = () => {
    if (!back) return;

    back?.();
  };

  const handleNext = () => {
    if (!next) return;

    next?.();
  };

  return (
    <Step id={id}>
      <>
        <div
          className={cn(
            "min-h-[calc(100dvh-var(--header-height)-var(--footer-height))] form-container pb-4 pt-5",
            className
          )}
          {...props}
        >
          {children}
        </div>

        <div className="sticky bottom-0 left-0 right-0 h-[var(--footer-height)]  bg-gradient-to-t from-background via-background">
          <div className="h-full w-full flex items-center justify-center form-container gap-3">
            {back && (
              <Button
                className="flex-shrink-0"
                variant="outline"
                onClick={handleBack}
              >
                {backChildren}
              </Button>
            )}

            <Button
              className={cn("flex-1", nextDisabled && "opacity-50 cursor-not-allowed")}
              onClick={handleNext}
              disabled={!next}
            >
              {nextChildren}
            </Button>
          </div>
        </div>
      </>
    </Step>
  );
};
